import {datadogJsonParseError} from '@utils/datadog/datadog-action';

//Wrapper for the javascript JSON object
const horizonJSON = {
  /**
   * A wrapper for JSON.parse with basic error handling built-in. The error will be sent to Datadog as a custom error event.
   * @param text
   */
  parse: function horizonJsonParse(text) {
    let parsed;

    try {
      parsed = JSON.parse(text);
    } catch (e) {
      datadogJsonParseError(e);
    }

    return parsed;
  },
};

export default horizonJSON;
